import $ from "jquery";

const menu = () => {
    $(".js-menu-toggle").on("click", function (e) {
        if ($(window).width() < 1200) {
            e.preventDefault();
            $(".js-menu").toggleClass("active");
            $("body").toggleClass("lock");
            $("html").toggleClass("lock");
            $(this).toggleClass("is-active");
        }
    });

    $(".menu-item-has-children").on("click", function (e) {
        if ($(window).width() < 1200) {
            if (e.target == this) {
                $(this).children(".sub-menu").slideToggle();
                if ($(this).hasClass("opened")) {
                    $(this).removeClass("opened");
                } else {
                    $(this).addClass("opened");
                }

                $(this)
                    .siblings()
                    .each(function (index, value) {
                        var slider = $(value);
                        if (slider.hasClass("opened")) {
                            slider.removeClass("opened");
                            slider.children(".sub-menu").slideToggle();
                        }
                    });
            }
        }
    });

    $(".js-about-menu-item").on("click", function (e) {
        if ($(window).width() > 1199) {
            e.preventDefault();

            $(".js-about-menu").slideToggle();
            $(".js-service-menu").slideUp();
            $(this).children(".sub-menu").hide();

            toggleHeaderActiveClass();
        }
    });

    $(".js-services-menu-item").on("click", function (e) {
        if ($(window).width() > 1199) {
            e.preventDefault();

            $(".js-services-menu").slideToggle();
            $(".js-about-menu").slideUp();
            $(this).children(".sub-menu").hide();

            toggleHeaderActiveClass();
        }
    });

    $(".menu-item-has-children").on("click", function (e) {
        if ($(window).width() > 1199) {
            if (!$(this).hasClass("is-active")) {
                e.preventDefault();
            }

            if ($(this).hasClass("is-active")) {
                $(this).removeClass("is-active");
            } else {
                $(".menu-item-has-children").removeClass("is-active");
                $(this).addClass("is-active");

                if (!$(this).hasClass("js-services-menu-item")) {
                    $(".js-services-menu").slideUp();
                }
            }

            toggleHeaderActiveClass();
        }
    });

    function toggleHeaderActiveClass() {
        if ($(".menu-item-has-children").hasClass("is-active")) {
            $(".js-header").addClass("is-active");
        } else {
            $(".js-header").removeClass("is-active");
        }
    }
};

export default menu;
